<template>
  <v-app>
    <SideNav />
    <header class="adoption-tool__header">
      <div class="adoption-tool__header-container center-container">
        <div class="adoption-tool__header-top">
          <div class="adoption-tool__header-left">
            <h1 class="adoption-tool__main-title">Adoption Portal</h1>
          </div>
          <div class="adoption-tool__header-right">
            <div class="adoption-tool__sponsor-banner">
              <label class="adoption-tool__sponsor-banner-label">Sponsor:</label>
              <a href="#" class="adoption-tool__sponsor-banner-link">Blue Buffalo Organics</a>
            </div>
          </div>
        </div>
        <div class="adoption-tool__header-bottom">
          <div class="adoption-tool__header-filter-box">
            <input v-model="zipcode" class="adoption-tool__header-filter-input" placeholder="Zip Code"
              variant="outlined" type="number" />

            <v-select v-model="distanceSelect" :hint="`${distanceSelect.label}, ${distanceSelect.value}`"
              :items="distanceSelectOptions" item-title="label" item-value="value" label="Select" persistent-hint
              return-object single-line @update:modelValue="selectRadius"></v-select>
            <i class="material-icons adoption-tool__header-button bg-lightgreen"
              :class="{ isDisabled: !distanceFiltersReady }" @click.stop="filterByZip(zipcode)">search</i>
          </div>
          <div class="adoption-tool__header-filter-box">
            <i class="material-icons adoption-tool__header-button bg-lightgreen"
              @click.stop="petStore.openFavoritesModal()">favorite</i>
            <i class="material-icons adoption-tool__header-button bg-lightgreen"
              @click.stop="petStore.openSideNav()">tune</i>
          </div>
        </div>
        <div class="adoption-tool__header-meta-bar">
          <p 
          v-if="petsExist && !petStore.isLoading"
          class="adoption-tool__header-results-tag"
          >Showing <span>{{ petStore.resultCount }}</span> pets</p>
          <p 
          v-if="!petsExist && !petStore.isLoading"
          class="adoption-tool__header-results-tag"
          >We found no pets with those filters.</p>
          <div 
            v-if="petStore.isLoading"
            class="adoption-tool__header-results-tag">
              <v-progress-circular              
              indeterminate
              color="#787878"
              :size="20"
              :width="3"
            ></v-progress-circular>
          </div>

        </div>

        <!-- <p>
          Pets found: <span>{{ petStore.paginationData.count }}</span>
        </p> -->
      </div>
    </header>

    <v-main>
      <div class="center-container">
        <div class="pets-container">
          <div class="pet-list pet-list--infinite" v-if="petsExist">
            <PetCard :pet="pet" class="pet-card" v-for="pet in petStore.pets" :key="pet.id"
              @click="petStore.openPetDetailsModal(pet.id)" />
          </div>
          <div 
            v-if="petStore.isLoading  && petsExist"
            class="pet-list__loader">
              <v-progress-circular              
              indeterminate
              color="#787878"
              :size="20"
              :width="3"
              ></v-progress-circular>
          </div>
          <!-- <div class="pet-list-empty align-center" v-if="!petsExist && !petStore.isLoading">
            <h2>We found no pets with those filters.</h2>
          </div> -->
        </div>
      </div>
    </v-main>

    <PetDetailsModal />
    <FavoritesModal />
    <LoginPromptDialog />
  </v-app>
</template>

<script>
import PetCard from "./components/PetCard.vue";
import PetDetailsModal from "./components/PetDetailsModal.vue";
import FavoritesModal from "./components/FavoritesModal.vue";
import LoginPromptDialog from "./components/LoginPromptDialog.vue";
import SideNav from "./components/SideNav.vue";

import { usePetStore } from "./stores/PetStore";
export default {
  components: { SideNav, PetCard, PetDetailsModal, FavoritesModal, LoginPromptDialog },
  data() {
    return {
      zipcode: null,
      radius: null,
      distanceSelect: { label: null, value: null },
      distanceSelectOptions: [
        { label: "25 Miles", value: 25 },
        { label: "50 Miles", value: 50 },
        { label: "100 Miles", value: 100 },
        { label: "250 Miles", value: 250 },
        { label: "500 Miles", value: 500 },
        { label: "1000 Miles", value: 1000 },
      ],
    };
  },
  methods: {
    setInitialFilters() {
      this.zipcode = this.petStore.distanceFilters && this.petStore.distanceFilters.postalcode  ? this.petStore.distanceFilters.postalcode : null;
      this.radius = this.petStore.distanceFilters && this.petStore.distanceFilters.miles ? this.petStore.distanceFilters.miles : 100;
      this.distanceSelect = this.petStore.distanceFilters && this.petStore.distanceFilters.miles ? { label: this.petStore.distanceFilters.miles + " miles", value: this.petStore.distanceFilters.miles  } : { label: "100 miles", value: 100 };
    },
    filterByZip() {
      const radiusFilterData = {
        miles: this.radius,
        postalcode: this.zipcode,
      };
      this.petStore.updateDistanceFilters(radiusFilterData);
    },
    selectRadius(selectedOption) {
      this.radius = selectedOption.value;
    },
    getNextPets() {
      window.onscroll = () => {
        let bottomOfWindow =
          document.documentElement.scrollTop + window.innerHeight ===
          document.documentElement.offsetHeight;
        if (bottomOfWindow) {
          console.log("reached bottom");
          this.petStore.fetchPets();
        }
      };
    }
  },
  computed: {
    petsExist: function () {
      return this.petStore.pets.length > 0;
    },
    distanceFiltersReady: function () {
      return this.radius && this.zipcode;
    },
  },
  setup() {
    // console.log("setup");

    const petStore = usePetStore();
    petStore.init();

    return { petStore };
  },
  beforeMount() {
    // console.log("beforemount");
  },
  mounted() {
    // console.log("app mounted");
    this.setInitialFilters();
    this.getNextPets();
  },
};
</script>

<style lang="scss">
/* Global */

@import "scss/global/variables.scss";
@import "scss/global/mixins.scss";
@import "scss/global/breakpoints.scss";
@import "scss/global/layout.scss";
@import "scss/global/colors.scss";
@import "scss/global/fonts.scss";

body {
  font-family: "MyriadPro";
  color: $textgrey;
}

.adoption-tool {
  &__header-container {
    padding: 0 !important;
  }

  &__header-top {
    @include flex-sides;
    padding: 13px;
    background-color: #ffffff;

    @include desktop {
      padding: 8px 18px;

    }
  }

  &__header-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 10px;
  }

  &__main-title {
    font-weight: bold;
    font-size: rem(19);
    white-space: nowrap;

    @include desktop {
      font-size: 28px;
    }
  }

  &__header-button {
    height: 30px;
    width: 35px;
    padding: 4px 7px;
    margin-left: 5px;
    font-size: 2rem !important;
    border: 1px solid $lightgreyborder;
    color: $textgrey;
    border-radius: 13px;
    box-shadow: 0px 1px 3.5px 1px rgb(2 3 3 / 10%);
    transition: 0.25s all ease-in-out;
    cursor: pointer;

    &.isDisabled {
      cursor: auto;
      box-shadow: none;
      background-color: $lightgreyborder;
      opacity: 0.5;
      filter: grayscale(1);
    }
  }

  &__header-filter-box {
    margin-left: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    &:first-child {
      padding-left: 0;
      margin-left: 0;
    }

    input {
      display: block;
      width: 90px;
      //  min-width: initial;
      height: 30px;
      padding: 3px;
      text-align: center;
      font-size: rem(13);
      border-radius: 13px;
      box-shadow: 0px 1px 3.5px 1px rgb(2 3 3 / 10%);
      border: solid 0.3px $lightgreyborder;
      background-color: $lightblue;
      -moz-appearance: textfield;

      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      margin-right: 5px;

      @include desktop {
        height: 34px;
        font-size: 1.5rem !important;
      }
    }
    .v-field {
    grid-template-areas: initial;
    padding-right: 0;
    margin-right: 5px;
  }

  // Vuetify select styling start
  .v-input__details {
    display: none !important;
  }

  .v-field__outline {
    height: 30px;
    border-radius: 13px;
    overflow: hidden;
    border: 1px solid $lightgreyborder;
    box-shadow: 0px 1px 3.5px 1px rgb(2 3 3 / 10%);

    @include desktop {
      height: 34px;
    }

    &::before,
    &:after {
      opacity: 0 !important;
    }
  }

  .v-input__control {
    grid-area: initial;
  }

  .v-field__input {
    min-height: initial !important;
    padding: 9px 12px;
    background-color: $lightblue;
    border-radius: 13px;
    @include desktop {
      padding: 6px 12px;
      }
  }

  .v-field__overlay {
    display: none;
  }

  .v-field__append-inner {
    display: none !important;
  }

  .v-select__selection-text {
    font-size: rem(13);

    @include desktop {
      font-size: 1.5rem !important;
    }
  }
  }

  &__header-meta-bar {
    padding: 0 10px;
    margin-bottom: 15px;
    
  }
  &__header-results-tag {
    width: 100%;  
    padding: 5px;
    font-size: 1.4rem !important;
    color: #787878;
    border: 1px solid #d5d5d5;
    border-radius: 15px;
    text-align: center;
    
  }


  /* Vuetify Overrides */

  .v-navigation-drawer {
    position: absolute !important;
  }

  .v-dialog .v-overlay__content {
    // display: block !important;
  }

  .v-overlay__scrim {
    background-color: #fff !important;
    opacity: 1 !important;
  }



  // Vuetify select styling end


  &__sponsor-banner {
    white-space: nowrap;
  }

  &__sponsor-banner-label {
    font-size: rem(10);
    margin-right: 1em;
  }

  &__sponsor-banner-link {
    color: $textgrey;
    font-size: rem(15);
  }
}

.pets-container {
  padding-bottom: 60px;
}

.pet-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  // grid-auto-rows: 1fr;
  grid-column-gap: 20px;
  grid-row-gap: 20px;
  margin-bottom: 40px;

  &--infinite {
    margin-bottom: 0;
  }

  @include tablet {
    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: 15px;
    grid-row-gap: 15px;
  }

  @include desktop {
    grid-template-columns: repeat(4, 1fr);
  }

  &__loader {
    width: 100%;  
    padding-top: 15px;
    padding-bottom: 15px;
    // border: 1px solid #d5d5d5;
    // border-radius: 15px;
    text-align: center;
  }
}

/* WP */
.logged-in {
  .v-overlay {
    top: 33px;
  }
}
</style>


